<template>
    <div>
        <v-container fluid>
            <v-row>
                <v-col>
                    <h2 v-text="this.editing ? this.titulo : 'Nueva'"></h2>
                </v-col>
            </v-row>

            <v-form ref="formularioColor">
                <v-row align="center">
                    <v-col>
                        <v-text-field v-model="currentColor.nombre" :rules="[(v) => !!v || 'Nombre es necesario']"
                            label="Nombre" required>
                        </v-text-field>
                    </v-col>
                    <v-col>
                        <v-text-field v-model="currentColor.referencia" label="Referencia" required>
                        </v-text-field>
                    </v-col>
                    <v-col>
                        <v-text-field v-model="currentColor.ral" label="RAL" required>
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-form>

            <v-row align="center">
                <v-col align="center">
                    <v-btn v-if="this.editing" color="error" class="mr-2" @click="dialogBaseDelete = true">
                        Borrar
                    </v-btn>

                    <v-btn v-if="this.editing" color="success" @click="updateColor">
                        Actualizar
                    </v-btn>

                    <v-btn v-if="!this.editing" color="success" @click="saveColor">
                        Guardar
                    </v-btn>
                </v-col>
            </v-row>

            <v-dialog v-model="dialogBaseDelete" max-width="500px">
                <v-card>
                    <v-card-title class="text-h6">
                        ¿Estás seguro de borrar el color {{ currentColor.nombre }}?
                    </v-card-title>
                    <v-card-text>Se borrarán las Sugerencias IA generadas para ese color.</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeBaseDelete">
                            Cancelar
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="deleteBaseItemConfirm">
                            Borrar
                        </v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-row v-if="this.editing">
                <v-col>
                    <template>
                        <v-data-table v-if="currentColor.aditivo" :headers="tabla_aditivos" :items="currentColor.aditivo"
                            class="elevation-1" :items-per-page="-1" hide-default-footer>

                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-toolbar-title>Aditivos</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                            </template>

                            <template v-slot:item.cod_aditivo="{ item }">
                                <router-link :to="'/aditivos/' + item.cod_aditivo">
                                    {{ item.cod_aditivo }}
                                </router-link>
                            </template>

                        </v-data-table>
                    </template>
                </v-col>
                <v-col>
                    <template>
                        <v-data-table v-if="currentColor.formula" :headers="tabla_formulas" :items="currentColor.formula"
                            class="elevation-1">

                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-toolbar-title>Formulas</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                            </template>

                            <template v-slot:item.cod_formula="{ item }">
                                <router-link :to="'/formulas/' + item.cod_formula">
                                    {{ item.cod_formula }}
                                </router-link>
                            </template>

                        </v-data-table>
                    </template>
                </v-col>
            </v-row>

        </v-container>
    </div>
</template>
<script>
import { mapMutations } from "vuex";
import ColoresDataService from "@/services/ColoresDataService";

export default {
    name: "ColorId",
    props: ['id'],
    data() {
        return {
            editing: false,
            titulo: "",
            currentColor: {
                id_color: 0,
                nombre: "",
                referencia: "",
                ral: "",
            },
            tabla_aditivos: [
                { text: "Codigo", value: "cod_aditivo" },
                { text: "Descripción", value: "descripcion" },
            ],
            tabla_formulas: [
                { text: "Codigo", value: "cod_formula" },
                { text: "Descripción", value: "descripcion" },
            ],
            dialogBaseDelete: false,
        };
    },
    methods: {
        ...mapMutations("snackbar", ["setSnack"]),
        getColor(id) {
            ColoresDataService.get(id)
                .then((response) => {
                    this.currentColor = response.data;
                    this.titulo = this.currentColor.nombre;
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        updateColor() {
            ColoresDataService.update(this.currentColor.id_color, this.currentColor)
                .then((response) => {
                    this.setSnack({ message: "Actualizado correctamente", color: "success" });
                    this.$router.push({ name: "ColoresList" });
                })
                .catch((e) => {
                    if (e.response.data.detail) {
                        this.setSnack({ message: e.response.data.detail, color: "error" });
                    } else {
                        this.setSnack({ message: e.message, color: "error" });
                    }
                    console.log(e);
                });
        },
        deleteColor() {
            ColoresDataService.delete(this.currentColor.id_color)
                .then((response) => {
                    this.setSnack({ message: "Borrado correctamente", color: "success" });
                    this.$router.push({ name: "ColoresList" });
                })
                .catch((e) => {
                    console.log(e);
                    this.setSnack({ message: e.response.data.detail, color: "error" });
                });
        },
        saveColor() {
            let data = {
                nombre: this.currentColor.nombre,
                referencia: this.currentColor.referencia,
                ral: this.currentColor.ral,
            };
            if (this.$refs.formularioColor.validate()) {
                ColoresDataService.create(data)
                    .then((response) => {
                        this.setSnack({ message: "Creado correctamente", color: "success" });
                        this.$router.push({ name: "ColoresList" });
                    })
                    .catch((e) => {
                        if (e.response.data.detail) {
                            this.setSnack({ message: e.response.data.detail, color: "error" });
                        } else {
                            this.setSnack({ message: e.message, color: "error" });
                        }
                        console.log(e);
                    });
            }
        },
        closeBaseDelete() {
            this.dialogBaseDelete = false;
        },
        deleteBaseItemConfirm() {
            this.deleteColor();
            this.closeBaseDelete();
        },
    },
    mounted() {
        this.editing = false;
        if (this.$route.params.id) {
            this.getColor(this.$route.params.id);
            this.editing = true;
        }
    },
    watch: {
        '$route.params.id'(newId, oldId) {
            this.editing = false;
            this.currentColor = {
                id_color: 0,
                nombre: "",
                referencia: "",
                ral: "",
            };
        },
        dialogBaseDelete(val) {
            val || this.closeBaseDelete();
        },
    }
};
</script>